import { useState } from "react";
import { getConferenceCampaign, requiresConferencePayment } from "../../../../src/shared/conferenceCampaign";
import { PRICING_PLANS } from "../../../../src/shared/constants";
import Auth from "../../Auth";
import { SudoButton } from "../../sudokit/components/SudoButton";

export function ConferencePaywall({ userId, subscription, onUpdated, setToast, canAllowTrial = false }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const data = subscription?.data;
  const campaign = data?.conferenceCampaign;
  if (!getConferenceCampaign(campaign?.id)) return null;
  const required = requiresConferencePayment(data);

  async function allowTrial() {
    if (busy || !canAllowTrial) return;
    setBusy(true);
    setError(null);
    try {
      const result = await Auth.fetchWithIdToken("/api/conference/allow-trial", { userId });
      if (!result.success) throw new Error(result.message || "Could not allow trial access. Please try again.");
      await onUpdated();
      setToast(result.creditsGranted > 0 ? `Trial access allowed with ${result.creditsGranted.toLocaleString()} credits` : "Trial access allowed; existing balance preserved");
    } catch (err) {
      setError(err.message || "Could not allow trial access. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return <div className="flex flex-col gap-2">
    <span className={`my-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium w-fit ${required ? "bg-red-100 text-red-800" : "bg-green-100 text-green-800"}`}>
      {required ? "Active — payment required" : campaign.trialAccessGrantedAt ? "Trial access allowed by admin" : "Not active"}
    </span>
    {required && !data.hasPaid && canAllowTrial && <>
      <p className="text-xs text-gray-600">
        {campaign.category === "new"
          ? `Unblocks the app and grants the standard ${(PRICING_PLANS[data.version]?.trialQuota || 0).toLocaleString()} trial credits once.`
          : "Unblocks the app and preserves the remaining trial balance."}
        {" "}Conference attribution is kept.
      </p>
      <SudoButton onClick={allowTrial} variant="secondary" size="small" disabled={busy} state={busy ? "loading" : "default"}>
        Allow trial access
      </SudoButton>
    </>}
    {campaign.trialAccessGrantedByEmail && <span className="text-xs text-gray-600">Granted by {campaign.trialAccessGrantedByEmail}</span>}
    {error && <p className="text-xs text-red-700" role="alert">{error}</p>}
  </div>;
}
